import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  /* background-color: #c4c4c420; */
  /* border: 1px solid #323133;
  border-radius: 15px 15px 12px 12px; */
  width: fit-content;
  height: fit-content;

  border-radius: 12px;

  -webkit-box-shadow: 0px 0px 2px 1px rgba(194, 194, 194, 1);
  -moz-box-shadow: 0px 0px 2px 1px rgba(194, 194, 194, 1);
  box-shadow: 0px 0px 2px 1px rgba(194, 194, 194, 1);
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #323133;
  background-color: #323133;
  padding: 15px;
  border-radius: 12px 12px 0px 0px;

  color: white;
`;

export const TitleContent = styled.div`
  display: flex;
  gap: 10px;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  /* justify-content: space-between; */
  flex-direction: column;
  /* gap: 15px; */
`;

export const Title = styled.h2`
  font-size: 15px;
  font-weight: 500;
`;

export const ContentWrapper = styled.div`
  display: grid;
  grid-gap: 5px;
  width: 100%;
  padding: 15px;
  .link {
    font-size: 13px;
    text-decoration: underline;
    color: black;
    cursor: pointer;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 0px;
  padding: 15px;

  .sc-cOFTSb {
    font-size: 14px;
  }
  .sc-jIAOiI {
    font-size: 14px;
  }

  .sc-ezWOiH {
    font-size: 12px;
  }

  form {
    display: flex;
    gap: 10px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  width: 150px;
`;
